export default __webpack_public_path__ + "static/45-5061e4c55c555e8666ab22d8734c0bd4.png";